import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import './Footer.css';

const Footer = ({ onAdminNavigate }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    console.log('Suscripción al newsletter:', email);
    setEmail('');
    alert(t('footer.newsletterSuccess'));
  };

  const navigateTo = (path) => (e) => {
    e.preventDefault();
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <footer className="footer" id="contacto">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Columna 1: POLÍTICAS */}
            <div className="footer-column">
              <h3 className="footer-title">{t('footer.policies')}</h3>
              <ul className="footer-links">
                <li>
                  <a href="/terms-and-conditions" className="footer-link" onClick={navigateTo('/terms-and-conditions')}>
                    {t('footer.termsConditions')}
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" className="footer-link" onClick={navigateTo('/privacy-policy')}>
                    {t('footer.privacyPolicy')}
                  </a>
                </li>
                <li>
                  <a href="/refund-policy" className="footer-link" onClick={navigateTo('/refund-policy')}>
                    {t('footer.refundPolicy')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Columna 2: NEWSLETTER */}
            <div className="footer-column">
              <h3 className="footer-title">{t('footer.newsletter')}</h3>
              <p className="footer-text">
                {t('footer.newsletterText')}
              </p>
              <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <div className="newsletter-input-wrapper">
                  <input
                    type="email"
                    placeholder={t('footer.emailPlaceholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="newsletter-input"
                    required
                  />
                  <button type="submit" className="newsletter-submit">
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </form>
            </div>

            {/* Columna 3: JAVILAND */}
            <div className="footer-column">
              <h3 className="footer-title">{t('footer.javiland')}</h3>
              <ul className="footer-links">
                <li>
                  <a href="/quienes-somos" className="footer-link" onClick={navigateTo('/quienes-somos')}>
                    {t('footer.aboutUs')}
                  </a>
                </li>
                <li>
                  <a href="/tienda" className="footer-link" onClick={navigateTo('/tienda')}>
                    {t('header.store')}
                  </a>
                </li>
                <li>
                  <a href="/servicios" className="footer-link" onClick={navigateTo('/servicios')}>
                    {t('header.services')}
                  </a>
                </li>
                <li>
                  <a href="/bienestar" className="footer-link" onClick={navigateTo('/bienestar')}>
                    {t('footer.wellnessHub')}
                  </a>
                </li>
                <li>
                  <a href="/contacto" className="footer-link" onClick={navigateTo('/contacto')}>
                    {t('footer.contact')}
                  </a>
                </li>
                {typeof onAdminNavigate === 'function' && (
                  <li>
                    <a
                      href="/admin-login"
                      className="footer-link"
                      onClick={(e) => {
                        e.preventDefault();
                        onAdminNavigate();
                      }}
                    >
                      {t('footer.adminPanel')}
                    </a>
                  </li>
                )}
              </ul>
            </div>

            {/* Columna 4: FOLLOW US + Idioma */}
            <div className="footer-column">
              <h3 className="footer-title">{t('footer.followUs')}</h3>
              <p className="footer-text">
                {t('footer.followInstagram')}
              </p>
              <div className="footer-language-selector">
                <LanguageSelector />
              </div>
              <div className="social-links">
                <a href="https://www.instagram.com/javilandoficial/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-copyright">
        <div className="container">
          <div className="copyright-content">
            <span className="copyright-text">
              {t('footer.copyright')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
